import Vue from 'vue'
import Router from 'vue-router'
import {reqHub} from "../utils/reqHub"

const Index = resolve => require(['../views/Index'], resolve)
const Task = resolve => require(['../views/Task'], resolve)
const Mine = resolve => require(['../views/Mine'], resolve)
const Result = resolve => require(['../views/Result'], resolve)

Vue.use(Router)


//查询用户是否开通
let isOpenUser = false;
let errorTime = 0;
const checkUser = (to, from, next) => {
    //是否请求过接口
    if(!isOpenUser) {
        reqHub.getUserStatus(function(res){ //success cb

            isOpenUser = true;
            console.log(res)
            if(!res.lousUserFlag) { //为开通白条
                window.location.href = 'https://bt.jd.com/v3/mobile/rGuide_initGuideMobile?source=JD_zw&channelName=223';
            }
            next();
        }, function() {
            errorTime += 1;

            if(errorTime < 3) {  //接口失败尝试3次，超出3次失败进入错误页
                checkUser();
            }else {
                errorTime = 0;
                pageRouter.replace({'name': 'result', params: {'type': 'exception'}});
                next();
            }
        })
    }else{
        next();
    }
}

const routes = [
    {
        path: '/index',
        name: 'index',
        component: Index,
        beforeEnter: checkUser,
    },
    {
        path: '/mine',
        name: 'mine',
        component: Mine
    },
    {
        path: '/task',
        name: 'task',
        component: Task
    },
    {
        path: '/result/:type',
        name: 'result',
        component: Result
    },
    {path: '*', redirect: '/index'}
]
const pageRouter = new Router({
    // mode: 'history',
    // base: '/consumer/baitiaohome/',
    routes: routes
});

export default pageRouter;




// WEBPACK FOOTER //
// ./src/router/index.js